import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { GrayButton } from 'components';
import { FBBody, FBComment, FBHeader, InstagramPreview, TwitterPreview } from 'components/SocialPreviews';
import * as styles from './PostPreview.scss';
var PostPreview = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(PostPreview, _Component);

  var _super = _createSuper(PostPreview);

  function PostPreview(props) {
    var _this;

    _classCallCheck(this, PostPreview);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "renderFBPreview", function (post) {
      var username = null;
      var media = [];
      var linkAttachment = null;

      if (post.attachments) {
        var loopAttachments = function loopAttachments(attachments) {
          attachments.forEach(function (attach) {
            if (attach.facebookObjectType === 'ATTACHMENT_SHARE') {
              return;
            }

            if (attach.details && attach.details.media && attach.details.media.image || attach.media && attach.media.image) {
              var src = attach.details && attach.details.media ? attach.details.media.image.src : attach.media.image.src;
              media.push(src);
            }

            if (attach.details && attach.details.subattachments && attach.details.subattachments.data) {
              loopAttachments(attach.details.subattachments.data);
            }
          });
        };

        loopAttachments(post.attachments);
        linkAttachment = post.attachments.find(function (a) {
          return a.facebookObjectType === 'ATTACHMENT_SHARE';
        });
      }

      console.log('media list is', media);
      var header = /*#__PURE__*/React.createElement(FBHeader, {
        dateText: moment(post.details && post.details.created_time ? post.details.created_time : post.createdAt)
      });
      var body = /*#__PURE__*/React.createElement(FBBody, {
        message: post.details.message,
        media: media,
        link: linkAttachment ? {
          title: linkAttachment.details.title,
          target: linkAttachment.details.target.url,
          image: linkAttachment.details.media ? linkAttachment.details.media.image.src : null,
          description: linkAttachment.details.description
        } : null
      });

      if (post.facebookObjectType === 'PAGE_RATING') {
        username = post.details.reviewer.name;
        var avatar = post.details.reviewer.picture ? post.details.reviewer.picture.data.url : '';
        header = /*#__PURE__*/React.createElement(FBHeader, {
          dateText: moment(post.details && post.details.created_time ? post.details.created_time : post.createdAt),
          pageName: username,
          avatarUrl: avatar,
          rating: post.details.rating ? post.details.rating : '',
          ratingSubject: post.details.open_graph_story && post.details.open_graph_story.data ? post.details.open_graph_story.data.seller ? post.details.open_graph_story.data.seller.title : post.details.open_graph_story.data.generic_place ? post.details.open_graph_story.data.generic_place.title : 'Unknown' : 'Unknown',
          reviewType: post.details.recommendation_type
        });
        body = /*#__PURE__*/React.createElement(FBBody, {
          message: post.details.review_text ? post.details.review_text : '',
          media: media,
          link: linkAttachment ? {
            title: linkAttachment.details.title,
            target: linkAttachment.details.target.url,
            image: linkAttachment.details.media ? linkAttachment.details.media.image.src : null,
            description: linkAttachment.details.description
          } : null
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: styles.fbWrap
      }, header, body);
    });

    _defineProperty(_assertThisInitialized(_this), "renderInstagramPreview", function (post) {
      console.log('in renderInstagramPreview()');
      console.dir(post);
      var message = post.details && post.details.caption ? post.details.caption.text : '';
      var postTime = '2 Days Ago';
      var videos = []; // multiple image posts come through in post.details.carousel_media array
      // for now, not supporting multiple images

      return /*#__PURE__*/React.createElement(InstagramPreview, {
        image: post.details.images.standard_resolution.url,
        location: post.details.location,
        message: message,
        numLikes: post.details.likes.count,
        postTime: postTime,
        profileImage: post.details.user.profile_picture,
        username: post.details.user.username,
        videos: videos
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderTwitterPreview", function (post) {
      var nothing = '';
      console.log('renderTwitterPreview()');
      console.log(post);
      var images = post.details.entities.hasOwnProperty('media') ? post.details.entities.media : false;
      var quote = null;
      console.log('details: ', post.details);

      if (post.details.is_quote_status) {
        var q = post.details.quoted_status;
        var text = q.text ? q.text.replace("@".concat(q.in_reply_to_screen_name, " "), '') : '';
        quote = {
          username: q.user.name,
          handle: q.user.screen_name,
          replyToHandle: q.in_reply_to_screen_name,
          text: text
        };
      }

      return /*#__PURE__*/React.createElement(TwitterPreview, {
        quote: quote,
        images: images,
        message: post.details.text,
        numLikes: post.details.favorite_count,
        numReplies: post.details.replies.length,
        numRetweets: post.details.retweet_count,
        postTime: moment(post.details.created_at).format('h:mm A - D MMM YYYY'),
        profileImage: post.details.user.profile_image_url_https,
        username: post.details.user.name,
        handle: "@".concat(post.details.user.screen_name)
      });
    });

    _this.state = {};
    return _this;
  }

  _createClass(PostPreview, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          post = _this$props.post;
      var renderedPost;

      switch (type) {
        case 'FACEBOOK_PAGE_POST':
          renderedPost = this.renderFBPreview(post);
          break;

        default:
          renderedPost = null;
          break;
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: styles.wrap
      }, renderedPost));
    }
  }]);

  return PostPreview;
}(Component), _defineProperty(_class2, "defaultProps", {}), _defineProperty(_class2, "propTypes", {
  post: PropTypes.object.isRequired,
  onDelete: PropTypes.func
}), _temp)) || _class);
export default PostPreview;